import React from 'react';

import { cssMap, cx } from '@atlaskit/css';
import { Anchor, Box, Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import type { ActionElement } from '../../dynamic-layout-parser/types/dynamic-layout-section';

interface ActionCardComponentProps {
	component: ActionElement;
}

const styles = cssMap({
	anchor: {
		textDecoration: 'none',
		'&:hover': {
			textDecoration: 'none',
		},
	},
	imageWrapper: {
		width: '48px',
		height: '48px',
		borderRadius: token('radius.medium'),
		overflow: 'hidden',
		backgroundSize: 'cover',
		backgroundImage: `url("https://remoteworksource.com/wp-content/uploads/2022/04/Forma.jpg")`,
	},
	container: {
		width: '295px',
		paddingTop: token('space.200'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.200'),
		backgroundColor: token('color.background.accent.gray.subtlest'),
		borderRadius: token('radius.small'),
		'&:hover': {
			backgroundColor: token('color.background.accent.gray.subtlest.hovered'),
			cursor: 'pointer',
		},
	},
	summaryBox: {
		maxWidth: '220px',
	},
});

export const DynamicLayoutActionCard = ({
	component,
}: ActionCardComponentProps): React.JSX.Element | null => {
	const url = component.attributes?.url || '';
	const title = component.attributes?.title || '';
	const text = component.attributes?.text || '';

	return title || text ? (
		<Anchor
			href={url}
			xcss={styles.anchor}
			aria-label=""
			tabIndex={-1}
			testId="dynamic-layout-action-card"
		>
			<Inline xcss={cx(styles.container)} space="space.200" alignBlock="center">
				<Box xcss={styles.imageWrapper}></Box>
				<Stack space="space.050">
					{title && (
						<Text weight="bold" maxLines={1}>
							{title}
						</Text>
					)}
					{text && (
						<Box xcss={styles.summaryBox}>
							<Text color="color.text.subtle" size="small" maxLines={2}>
								{text}
							</Text>
						</Box>
					)}
				</Stack>
			</Inline>
		</Anchor>
	) : null;
};
